import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./components/Navbar/Theme";

import Navbar from "./components/Navbar/Navbar";
import Intro from "./components/Home/Intro";
import Work from "./components/Works/Work";
import Cursor from "./components/Navbar/Cursor";
import SmoothScroll from "./components/Navbar/SmoothScroll";
import ScrollToTop from './components/Navbar/ScrollToTop';

function App() {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <SmoothScroll>
          <div className="App">
            {isDesktop && <Cursor />}

            <div className="background1"></div>

            <Navbar />

            <Routes>
              <Route path="/" element={<Intro />} />
              <Route path="/work" element={<Work />} />
            </Routes>
          </div>
        </SmoothScroll>
      </Router>
    </ThemeProvider>
  );
}

export default App;